// Explicit mappings to existing CRM controls. See docs/AI_FIELD_HIGHLIGHTS.md.
export default {
  contact: [
    'accepts_newsletters',
    'accepts_privacy_policy',
    'ahv_n13',
    'birthdate',
    'degree_employment',
    'denomination',
    'email',
    'email_2',
    'employed_since',
    'employer',
    'first_name',
    'gender',
    'has_debt_enforcement',
    'has_pension_potential',
    'income_type',
    'is_property_owner',
    'language',
    'last_name',
    'location',
    'marital_status',
    'marital_status_since',
    'mobile',
    'nationalities',
    'ownership_type',
    'phone',
    'phone_2',
    'postcode',
    'profession',
    'residence_permits',
    'residence_permits_since',
    'street',
    'street_no',
    'year_of_birth',
  ],
  finance: [
    'asset_gifts',
    'asset_inheritance_advances',
    'asset_loans',
    'asset_loans_amortization',
    'asset_loans_duration',
    'asset_loans_interests_rate',
    'asset_total',
    'expense_alimony_total',
    'expense_consumer_credit',
    'expense_leasing',
    'expense_loans',
    'expense_loans_amortization',
    'expense_loans_duration',
    'expense_loans_interests_rate',
    'expense_other',
    'expense_rent',
    'income_additional_regular',
    'income_alimony_total',
    'income_asset_depletion',
    'income_bonus_before_last_year',
    'income_bonus_current',
    'income_bonus_last_year',
    'income_dividends',
    'income_gross',
    'income_iv_children',
    'income_net',
    'income_net_rental_real_estate',
    'income_pension',
    'income_pension_ahv',
    'income_pension_bvg',
    'income_secondary',
    'income_self_employment_before_last_year',
    'income_self_employment_current',
    'income_self_employment_last_year',
    'orphans_pension',
    'pension_additional_asset_depletion',
    'pension_additional_income',
    'pension_additional_pension',
    'pension_assets_current',
    'pension_assets_current_vested',
    'pension_assets_projected_retirement',
    'pension_death_benefits',
    'pension_death_benefits_max',
    'pension_income_iv',
    'pension_income_retirement',
    'pension_income_retirement_bvg',
    'pension_reported_annual_salary',
    'pension_wef_pledging_possible_amount',
    'pension_wef_pledging_registered_status',
    'pension_wef_withdrawal_registered_payout_amount',
    'pension_wef_withdrawal_registered_repaid_amount',
  ],
  financial_account: [
    'company',
    'life_insurance_payout',
    'product',
    'redemption_value_gross',
    'total_amount',
    'type',
  ],
  mortgage_interest: [
    'end_date',
    'interest_rate',
    'property_value',
    'remaining_amount',
  ],
  child: [
    'birthdate',
    'education_until',
    'first_name',
    'gender',
    'is_in_education',
    'last_name',
    'role',
  ],
  pension: [
    'balance_at_maturity',
    'cancel_reason',
    'canceled_at',
    'due_on',
    'institute_consultant_id',
    'institute_id',
    'institute_product_id',
    'pension_state',
    'pension_type',
    'repayment',
    'repayment_repaid_at',
    'sum_insured',
    'total_insurance_premium',
    'valid_from',
  ],
  property: [
    'address',
    'apartments_no',
    'area_balcony_terrace',
    'area_floor_gross',
    'area_floor_net',
    'area_garden',
    'area_hobby_room',
    'area_land',
    'bathroom_condition',
    'bathroom_quality',
    'bathroom_wc_or_shower_wc_no',
    'bathrooms_no',
    'building_law_end_date',
    'building_law_rent',
    'building_quality',
    'cadaster_no',
    'condition_of_the_building',
    'cubature',
    'cubature_type',
    'egrid',
    'equity',
    'financial_type',
    'financial_value',
    'floor',
    'floor_plan',
    'flooring_condition',
    'flooring_quality',
    'floors_no',
    'funding_financial_value',
    'has_alternative_use',
    'has_building_automation',
    'has_building_ventilation',
    'has_direct_elevator_access',
    'has_elevator',
    'has_elevator_staircase',
    'has_fireplace',
    'has_freight_elevator',
    'has_heated_winter_garden',
    'has_indoor_pool',
    'has_jacuzzi_sauna_whirlpool',
    'has_obligations',
    'has_outdoor_pool',
    'has_right_of_residence',
    'has_security_system',
    'has_shared_garden_terrace_extra_room',
    'has_unheated_winter_garden',
    'has_value_reducing_easements',
    'heat_distribution',
    'heat_efficiency_class',
    'heat_production',
    'is_barrier_free',
    'is_in_agricultural_zone',
    'is_luxury_object',
    'is_outside_building_zone',
    'is_under_building_law',
    'is_under_monument_protection',
    'is_under_usufruct',
    'kitchen_condition',
    'kitchen_quality',
    'land_register_municipality',
    'liquid_assets',
    'location',
    'location_in_the_building_rating',
    'masonry_condition',
    'mortgage_increase',
    'mortgage_increase_purpose',
    'notes',
    'object_financing_deadline',
    'object_financing_remarks',
    'object_state',
    'object_type',
    'object_usage',
    'ownership',
    'parking_garage_box',
    'parking_garage_outside_property',
    'parking_indoor',
    'parking_outdoor',
    'pension_fund',
    'pension_fund_type',
    'pledge',
    'postcode',
    'property_type',
    'purchase_date',
    'refinancial_value',
    'remarks',
    'renovations',
    'rental_income_net',
    'reversion_compensation',
    'room_height',
    'room_no_secondary_suite',
    'rooms_no',
    'servitudes',
    'street_no',
    'third_pillar',
    'third_pillar_type',
    'value_ratio',
    'volume_tranches',
    'wcs_no',
    'window_condition',
    'window_quality',
    'year_construction',
  ],
  tranche: [
    'due_on',
    'duration',
    'duration_type',
    'finance_institute',
    'institute_consultant_id',
    'institute_id',
    'institute_product_id',
    'interest_percentage',
    'tranche_state',
    'tranche_type',
    'valid_from',
    'volume',
  ],
  object_insurance: [
    'annual_insurance_premium',
    'cancel_reason',
    'canceled_at',
    'due_on',
    'institute_consultant_id',
    'institute_id',
    'institute_product_id',
    'object_insurance_state',
    'object_insurance_type',
    'repayment',
    'repayment_repaid_at',
    'sum_insured',
    'valid_from',
  ],
}
